export default __webpack_public_path__ + "6b5eee0bb723d142ff400a32996e24d0.png";